(function (angular) {
    function getMessage($translationService, errorCode) {
        if ($translationService.existTranslation(errorCode)) {
            return $translationService.getTranslation(errorCode);
        }

        return errorCode;
    }    
    angular.module('shared').service('$message', ['$mdToast', "$q", "$translationService", function ($mdToast, $q, $translationService) {            
            return {                
                error: function (error) {
                    var message = "";
                    if (_.isObject(error)) {
                        if (error.config) {
                            if (error.config.timeout) {
                                if (error.config.timeout.status === "CANCEL") {
                                    return $q.reject("timeout");
                                }
                            }
                        }
                        if (error.status === -1) {
                            message = "UnableConnectToServer";
                        }else if (error.status === 404) {
                            message = "Method not found.";
                        } else {
                            message = error.data.code || error.data.message;
                        }

                        if (!message) {
                            message = error.status + "";
                        }
                    }
                    else {
                        message = error;
                    }
                    message = getMessage($translationService, message);

                    // setTimeout to workarround some cases that the error message blocing on screen
                    // Don't show error if skipShowAPIError is true
                    if(!error.skipShowAPIError) {
                        setTimeout(() => {
                            $mdToast.show($mdToast.simple()
                                .position("right top")
                                .textContent(message)
                                .hideDelay(3000));
                        }, 100);
                    }
                    return $q.reject(message);
                },
                infor: function (messageCode) {
                    message = getMessage($translationService, messageCode);

                    var toastpreset = $mdToast.simple()
                        .position("right top")
                        .textContent(message)
                        .hideDelay(4000)
                        .theme("custom-infor-theme");
                    $mdToast.show(toastpreset);
                },
                get: function (errorCode) {
                    return getMessage($translationService, errorCode);
                }
            };            
        }]);
}(angular));
